import * as actions from './actions/index';
import securityCheck from './actions/securityCheck';

export default class Actions {
  init() {
    [...Object.keys(actions)].forEach(actionIdentifier => {
      [...document.querySelectorAll(`[data-action="${actionIdentifier}"]`)].forEach(element => {
        element.addEventListener('click', this.callAction.bind(this));
      });
    });

    [...document.querySelectorAll('form[data-confirm]')].forEach(element => {
      element.addEventListener('submit', this.confirmFormSubmission.bind(this));
    });
  }

  callAction(event) {
    const actionIdentifier = event.currentTarget.getAttribute('data-action');
    const actionFunction = actions[actionIdentifier];

    if (actionFunction) {
      actionFunction(event.currentTarget);
    }
  }

  confirmFormSubmission(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const confirmMessage = form.getAttribute('data-confirm');

    if (!securityCheck(confirmMessage)) {
      return false;
    }

    form.submit();

    return true;
  }
}
